export default __webpack_public_path__ + "static/media/voteSuccess.83712561.svg";